import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import TextInput from '../../../../components/Forms/TextInput';
import { getModalsState } from '../../../modals/modalsSlice';
import AutocompleteInputUsers from '../../../users/components/AutocompleteInputUsers';
import { nestUserIdIris } from '../../../users/utils';
import { createFolderThunk, updateFolderThunk } from '../../services/foldersThunks';
import './foldersForm.scss';
import { createInitialValues, schema } from './form';

interface IFolderFormContentProps {
  isModal?: boolean;
  handleCancel: () => void;
}

function FolderFormComponent({ isModal, handleCancel }: IFolderFormContentProps) {
  const navigate = useNavigate();
  const { updateFolder } = useAppSelector(getModalsState);

  const dispatch = useAppDispatch();
  const formik = useFormik({
    initialValues: updateFolder ?? createInitialValues,
    validationSchema: schema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const body = {
        name: values.name,
        collaborators: nestUserIdIris(values.collaborators),
      };

      if (values.idIri) {
        dispatch(updateFolderThunk({ folderIdIri: values.idIri, body, navigate }));
      } else {
        dispatch(createFolderThunk({ body, navigate }));
      }
    },
  });

  const { values, touched, errors } = formik;

  return (
    <div className="my-folders-form">
      <div className={isModal ? 'my-folders-form-modal' : 'my-folders-form-sub'}>
        {values && (
          <>
            <TextInput
              label="Titre du dossier"
              name="name"
              value={values.name}
              handleChange={formik.handleChange}
              error={touched.name && Boolean(errors.name)}
              // helperText={errors.name}
            />

            <AutocompleteInputUsers
              value={values.collaborators}
              handleChange={formik.setFieldValue}
              multiple
            />
          </>
        )}
      </div>
      <div className="my-folders-form-btn-group">
        <Button
          btnType="button"
          btnContent="ENREGISTRER"
          handleClick={() => formik.handleSubmit()}
          primary
        />
        <Button
          btnType="button"
          btnContent="ANNULER"
          handleClick={handleCancel}
          textColor="violet"
          bgColor="white"
          borderColor="grey"
        />
      </div>
    </div>
  );
}

export default FolderFormComponent;
